import Heading1 from './h1.vue'
import Paragraph from './p.vue'

export default {
  h1: props => ({
    render (h) {
      return (
        <Heading1 {...props}>
          {this.$slots.default}
        </Heading1>
      )
    }
  }),
  p: props => ({
    render (h) {
      return (
        <Paragraph {...props}>
          {this.$slots.default}
        </Paragraph>
      )
    }
  })
}
